import React from 'react'

import { Label } from 'components/base/Form/InsuranceTypeRadio/styles'

import { Props } from './types'

import {
  Container,
  Image,
} from './styles'

const ComingSoon: React.FC<Props>  = ({
  name,
  insuranceType,
  children,
}): React.ReactElement => (
  <Container
    htmlFor={name}
  >
    <Image
      key='color'
      insuranceType={insuranceType}
      isColor={true}
    />
    <Label
      insuranceType={insuranceType}
    >
      {children}
    </Label>
  </Container>
)

export * from './types'

export default ComingSoon
